import React, { useState, useEffect } from 'react';
import {
  Content,
  Row,
  Col,
  Text,
  // DropDownMenu,
  ProductItem,
  // Pagination,
  Title,
  HtmlContent,
} from 'components';
import { encrypt } from 'utils/Crypto';
import { Badge, Empty, Result, Spin, Button } from 'antd';
import Cart from 'assets/icon/cart_icon.png';
import Heart from 'assets/icon/heart_icon.png';
import { HeartFilled } from '@ant-design/icons';
import dayjs from 'dayjs';

const PromotionDetailPresenter = (props) => {
  const {
    navigate,
    location,
    // promotion,
    products,
    cartList,
    setModalData,
    user,
    onSubmit,
    sortItems,
    screenSize,
    data = null,
    type = 'PROMOTION',
  } = props;

  const [tabKey, setTabKey] = useState(sortItems[0].key);
  const [isLoading] = useState(false);
  const [productItems, setProductItems] = useState([]);

  const handleRenderModal = (t, d = null) => {
    if (!user) {
      const confirm = window.confirm(
        '로그인 후 이용가능합니다.\n로그인하시겠습니까?'
      );

      if (confirm) {
        navigate('signin', {
          state: {
            from: `${location.pathname}${
              location.search ? location.search : ''
            }`,
          },
        });
      } else {
        return;
      }
    }

    if (t === 'wishlist' && d.isWish) {
      const confirm = window.confirm('찜 목록에서 삭제하시겠습니까?');

      if (confirm) {
        return onSubmit('remove', d);
      } else {
        return;
      }
    }

    if (!d) return setModalData({ type: '', data: null });
    else setModalData({ type: t, data: d });
  };

  useEffect(() => {
    setProductItems(products);
  }, [products]);

  useEffect(() => {
    const tapSplit = tabKey.split('-');
    const sortData = [...productItems]?.sort((a, b) => {
      switch (tapSplit[0]) {
        case 'ASC':
          return a[tapSplit?.[1]] - b[tapSplit?.[1]];
        case 'DESC':
          return b[tapSplit?.[1]] - a[tapSplit?.[1]];
        default:
          return 0;
      }
    });
    setProductItems(sortData);
    // eslint-disable-next-line
  }, [tabKey]);

  useEffect(() => {
    setTabKey(sortItems[0].key);
  }, [sortItems]);

  /**
   * 타입 키
   * --
   */
  const typeKey = React.useMemo(() => {
    return type === 'RECIPE' ? `group_product` : 'promotion';
  }, [type]);

  if (!data)
    return (
      <Content maxWidth={'100%'} padding={30}>
        <Result
          status="404"
          title="페이지를 찾을 수 없음"
          subTitle="요청하신 페이지를 찾을 수 없습니다."
          extra={
            <Button type="primary" onClick={() => navigate(-1)}>
              뒤로가기
            </Button>
          }
        />
      </Content>
    );

  return (
    <Spin spinning={isLoading}>
      <Content maxWidth={'100%'} padding={0} className="brand_detail">
        <Row style={{ maxWidth: 2560, margin: '0 auto' }}>
          <Col x={24}>
            <Content maxWidth={'100%'} padding={0}>
              <div
                style={{
                  background: '#EFEFEF',
                }}
              >
                <Content
                  maxWidth={1500}
                  style={{
                    width: 'calc(100% - 60px)',
                    backgroundColor: 'transparent',
                    padding: screenSize >= 768 ? '100px 0' : '80px 0',
                  }}
                >
                  {/* 제목 */}
                  <div>
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        rowGap: 20,
                      }}
                    >
                      <Title
                        className="dela-gothic"
                        style={{
                          fontSize: screenSize >= 768 ? 18 : 13,
                          border: '1px solid var(--light-gray-color)',
                          borderRadius: 50,
                          width: 'fit-content',
                          padding: '10px 12px 12px 12px',
                        }}
                      >
                        {type === 'RECIPE' ? 'Recipe' : 'Promotion'}
                      </Title>

                      <Title
                        style={{
                          fontSize: screenSize >= 768 ? 32 : 24,
                          fontWeight: 700,
                        }}
                      >
                        {data?.[`${typeKey}_title`]}
                      </Title>

                      <Text size={screenSize >= 768 ? 16 : 12}>
                        {data?.[`${typeKey}_description`]}
                      </Text>

                      {type === 'PROMOTION' ? (
                        <div
                          style={{
                            display: 'flex',
                            fontSize: screenSize >= 768 ? 16 : 14,
                            minWidth: 'fit-content',
                          }}
                        >
                          {dayjs
                            .unix(data?.promotion_start_date)
                            .format('YYYY.MM.DD')}
                          <p style={{ margin: '0 5px' }}>~</p>
                          {dayjs
                            .unix(data?.promotion_end_date)
                            .format('YYYY.MM.DD')}
                        </div>
                      ) : null}
                    </div>
                  </div>
                  {/* 내용 */}
                  <HtmlContent
                    content={data?.[`${typeKey}_content`]}
                    style={{
                      padding: 0,
                      paddingTop: screenSize >= 768 ? 60 : 40,
                    }}
                  />
                </Content>
              </div>
            </Content>
          </Col>
        </Row>

        {/* ===== 상품 목록 ===== */}
        <Content
          maxWidth={1500}
          padding={screenSize >= 1200 ? '100px 0px' : '80px 0'}
          style={{
            width:
              screenSize >= 768 ? 'calc(100% - 60px)' : 'calc(100% - 30px)',
          }}
        >
          <Content
            maxWidth={'100%'}
            padding={0}
            style={{
              marginBottom: screenSize >= 768 ? 80 : 20,
              borderBottom: '2px solid #111111',
              height: screenSize >= 768 ? 52 : 'auto',
              paddingBottom: 15,
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'flex-end',
            }}
          >
            <Text
              style={{
                webkitLineClamp: 'unset',
                minWidth: 'fit-content',
                fontSize: screenSize >= 768 ? 16 : 14,
              }}
            >
              총 <span style={{ fontWeight: 700 }}>{data.products.length}</span>{' '}
              건
            </Text>

            {/* <div style={{ display: 'flex', gap: 15 }}>
              <DropDownMenu
                items={sortItems.map((item) => ({
                  label: item.label,
                  value: item.key,
                }))}
                value={tabKey}
                onSelect={({ value }) => setTabKey(value)}
                layoutStyle={{ paddingLeft: 10 }}
              />
            </div> */}
          </Content>

          <Row gutter={screenSize >= 768 ? [60, 100] : [20, 30]}>
            {data.products.length ? (
              data.products.map((_item, _index) => (
                <Col x={12} md={8} lg={6} key={`product_${_index}`}>
                  <ProductItem
                    key={_item.key}
                    src={_item.src}
                    title={_item.title}
                    tags={_item.tags}
                    brand={_item.brand}
                    comment={_item.comment}
                    score={_item.score}
                    price={_item.price}
                    discount={_item.discount}
                    discountType={_item.discount_type}
                    discountPrice={_item.finalPrice}
                    hovered={false}
                    onClick={() =>
                      navigate(
                        `/products/${encodeURIComponent(encrypt(_item.key))}`
                      )
                    }
                    buttons={[
                      {
                        render: () =>
                          _item.isWish ? (
                            <HeartFilled
                              style={{ color: '#D33444', fontSize: 24 }}
                            />
                          ) : (
                            <img src={Heart} alt="찜하기" />
                          ),
                        onClick: (event) => {
                          handleRenderModal('wishlist', _item);
                          event.stopPropagation();
                        },
                      },
                      {
                        render: () => (
                          <Badge count={cartList}>
                            <img src={Cart} alt="장바구니" />
                          </Badge>
                        ),
                        onClick: (event) => {
                          handleRenderModal('cart', _item);
                          event.stopPropagation();
                        },
                      },
                    ]}
                  />
                </Col>
              ))
            ) : (
              <div
                style={{
                  width: '100%',
                  padding: '100px 0',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <Empty
                  description={
                    <Text size={18}>조건에 맞는 상품이 없습니다.</Text>
                  }
                />
              </div>
            )}
          </Row>
        </Content>
      </Content>
    </Spin>
  );
};

export default PromotionDetailPresenter;
